export default initialState =>
  (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case 'SET_EDITING_DRAWING_OVERLAY_ID':
        return {
          ...state,
          editingDrawingOverlayId: payload.drawingOverlayId,
        };
      case 'CLEAR_EDITING_DRAWING_OVERLAY_ID':
        return {
          ...state,
          editingDrawingOverlayId: null,
        };
      default:
        return state;
    }
  };
